import { Play, RotateCcw } from 'lucide-react';
import { Card, CardContent } from '@/components/ui/card';
import { Button } from '@/components/ui/button';
import { TOUR_ID, TOUR_VERSION } from '@/constants/tours';

interface TourTriggerProps {
  variant?: 'card' | 'button';
  className?: string;
}

export function TourTrigger({ variant = 'card', className }: TourTriggerProps) {
  const handleRestartTour = () => {
    // Clear tour completion from localStorage
    localStorage.removeItem(`${TOUR_ID}-completed`);
    localStorage.removeItem(`${TOUR_ID}-version`);

    // Reload page to trigger tour
    window.location.href = '/app';
  };

  if (variant === 'button') {
    return (
      <Button
        variant="outline"
        onClick={handleRestartTour}
        className={className}
      >
        <RotateCcw className="h-4 w-4 mr-2" />
        Restart Tour
      </Button>
    );
  }

  return (
    <Card className={`border-2 border-dashed border-primary/20 bg-primary/5 ${className}`}>
      <CardContent className="p-6">
        <div className="flex flex-col sm:flex-row items-center gap-4">
          <div className="p-3 rounded-full bg-primary/10">
            <Play className="h-8 w-8 text-primary" />
          </div>
          <div className="flex-1 text-center sm:text-left">
            <h3 className="font-semibold mb-1">Take the Guided Tour</h3>
            <p className="text-sm text-muted-foreground">
              New to VoiceThera? Let us show you around with an interactive walkthrough of all the features.
            </p>
          </div>
          <Button onClick={handleRestartTour} className="whitespace-nowrap">
            <Play className="h-4 w-4 mr-2" />
            Start Tour
          </Button>
        </div>
      </CardContent>
    </Card>
  );
}
